module.exports = __webpack_public_path__ + "img/image-icon.bddbf3e0.svg";